import type { ReactNode } from "react";
import { createContext, useContext } from "react";

export type WidgetRuntimeConfig = {
  apiKey: string;
  apiUrl: string;
  organizationSlug?: string;
  widgetDisclaimerText?: string;
  widgetSuggestedQuestions?: string[];
  showChatQuestions: boolean;
  widgetPlaceholderText: string;
  langfuse?: {
    baseUrl: string;
    publicKey: string;
    environment?: string;
  } | null;
};

type WidgetRuntimeConfigProviderProps = {
  value: WidgetRuntimeConfig;
  children: ReactNode;
};

const WidgetRuntimeConfigContext = createContext<WidgetRuntimeConfig | null>(null);

export const WidgetRuntimeConfigProvider = ({
  value,
  children,
}: WidgetRuntimeConfigProviderProps) => {
  return (
    <WidgetRuntimeConfigContext value={value}>
      {children}
    </WidgetRuntimeConfigContext>
  );
};

export const useWidgetRuntimeConfig = (): WidgetRuntimeConfig => {
  const config = useContext(WidgetRuntimeConfigContext);
  if (!config) {
    throw new Error("Widget runtime config is missing.");
  }
  return config;
};
